import { render, staticRenderFns } from "./Securities.vue?vue&type=template&id=81730368&"
import script from "./Securities.vue?vue&type=script&lang=js&"
export * from "./Securities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports